import React from 'react';
import style from "../pagination.module.scss"
import Select from 'react-select';
import cn from "classnames";

const DefaultPaginationItems = ({selectedValue, onChange }) => {
  const paginationOptions = [
    { id: 5, name: '5' },
    { id: 10, name: '10' },
    { id: 15, name: '15' },
    { id: 20, name: '20' },
    { id: 50, name: '50' },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      display: 'flex',
      padding: '8px 12px',
      gap: '8px',
      cursor:'pointer',
      borderRadius: '8px',
      border: '1px solid #E6E0EC',
      borderColor: state.isFocused ? '#212121' : '#E6E0EC',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'none',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      width: '20px',
      justifyContent: 'center',
      padding: '0'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0',
      color: '#6D7885',
      '&:hover': {
        color: 'none',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#EFEFEF' : state.isFocused ? '#FAFAFA' : null,
      color: '#141619',
      cursor: 'pointer',
      padding: '8px 12px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '4px',
      marginTop: '4px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#141619',
    }),
  };

  return (
    <div className={style.pagination_item}>
      {/* <span className={style.paginationLabel}>Показать на странице</span> */}

      <Select
        defaultValue={paginationOptions[1]}
        onChange={onChange}
        placeholder=""
        // className={style.}
        // classNamePrefix={style.}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        styles={customStyles}
        options={paginationOptions}
        value={paginationOptions.find(option => option.id === selectedValue)}
        isSearchable={false}
        menuPlacement="top"
      />
    </div>
  );
};

export default DefaultPaginationItems;